import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

const HeroSection = () => {
  return (
    <section className="hero-contact">
      <Container fluid="lg">
        <Row className="contact-header">
          <div className="contact-header__left">
            <h1 className="title">Contacta</h1>
            <p className="text">
              Impulso educación, divulgación y acciones políticas para garantizar
              los derechos de todas las mujeres, reconociendo la diversidad de
              sus experiencias y condicionantes socioculturales. Contacta
              conmigo para asesoría, colaboración o participación en proyectos
              que generen un cambio real y transformador.
            </p>
            <a href="#contact-form" className="main-btn">
              Ponte en contacto
            </a>
          </div>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
